import One from "./1.jpg";
import Two from "./2.jpg";
import Three from "./3.jpg";

const FloorplanRoom = [One, Two, Three];
export default FloorplanRoom;
